module.exports = __webpack_public_path__ + "img/customer_service.afde44d3.jpg";